"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmModal = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("skybase-ui/skybase-core/shapes");

var _skybaseComponents = require("skybase-ui/skybase-components");

var _sbModal = require("skybase-ui/skybase-components/sb-modal");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _messagesI18n = require("../../messages-i18n");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _ConfirmModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(_ConfirmModal, _PureComponent);

  var _super = _createSuper(_ConfirmModal);

  function _ConfirmModal() {
    var _this;

    (0, _classCallCheck2.default)(this, _ConfirmModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHeader", function () {
      var _this$props = _this.props,
          title = _this$props.title,
          handleOverlayClick = _this$props.handleOverlayClick;
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModalHeader, {
        title: title,
        onCloseBtnClick: handleOverlayClick
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnConfirmClick", function () {
      var handleOnConfirm = _this.props.handleOnConfirm;
      handleOnConfirm();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFooter", function () {
      var _this$props2 = _this.props,
          confirmButtonTitle = _this$props2.confirmButtonTitle,
          cancelButtonTitle = _this$props2.cancelButtonTitle,
          handleOverlayClick = _this$props2.handleOverlayClick,
          hideCancelButton = _this$props2.hideCancelButton,
          _ = _this$props2.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-footer fl-container fl-justify-end"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-left"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-center"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-right"
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButton, {
        className: "primary",
        onClick: _this.handleOnConfirmClick
      }, confirmButtonTitle || _(_messagesI18n.messages.confirm)), !hideCancelButton && /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButton, {
        onClick: handleOverlayClick
      }, cancelButtonTitle || _(_messagesI18n.messages.cancel))));
    });
    return _this;
  }

  (0, _createClass2.default)(_ConfirmModal, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          handleOverlayClick = _this$props3.handleOverlayClick,
          message = _this$props3.message;
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModal, {
        onClickOverlay: handleOverlayClick,
        Header: this.renderHeader(),
        Footer: this.renderFooter(),
        width: 300,
        height: "auto",
        className: "confirm-modal"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-message-modal-content m-b-10"
      }, message));
    }
  }]);
  return _ConfirmModal;
}(_react.PureComponent);

(0, _defineProperty2.default)(_ConfirmModal, "propTypes", {
  intl: _shapes.intlShape.isRequired,
  title: _propTypes.default.string.isRequired,
  message: _propTypes.default.node.isRequired,
  confirmButtonTitle: _propTypes.default.string,
  cancelButtonTitle: _propTypes.default.string,
  handleOnConfirm: _propTypes.default.func.isRequired,
  handleOverlayClick: _propTypes.default.func.isRequired,
  hideCancelButton: _propTypes.default.bool
});
(0, _defineProperty2.default)(_ConfirmModal, "defaultProps", {
  cancelButtonTitle: null,
  confirmButtonTitle: null,
  hideCancelButton: false
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleOverlayClick: function handleOverlayClick() {
      return dispatch((0, _actions.closeModal)());
    }
  };
};

var ConfirmModal = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(null, mapDispatchToProps)(_ConfirmModal));
exports.ConfirmModal = ConfirmModal;
//# sourceMappingURL=confirm-modal.js.map